import Payments from '~/stores/payments';
import api from '~/utils/api';
import { ClaimType } from '~/utils/constants';
import { formatDisplayValue, toCurrency } from '~/utils/formatters';
import { pendingLineItemClaimToCalculatedLineItem } from '~/utils/line-item-claim';
import { makeCrewLoaderWithLineItemClaims } from '~/utils/routing';

export const { loader, useLoaderData: useWarrantyReviewData } =
  makeCrewLoaderWithLineItemClaims(async ({ context }) => {
    const { settings, returnMethod, toCustomerRate, order, lineItemClaims } =
      context;

    const monetarySettings = await api.calculateBeforeClaimSubmission({
      params: { storefrontId: settings.storefrontId },
      body: {
        id: order.id,
        claimType: ClaimType.warranty,
        calculatedLineItems: lineItemClaims.map((claim) =>
          pendingLineItemClaimToCalculatedLineItem(claim),
        ),
        returnShipment: returnMethod,
        toCustomerRate,
      },
    });

    const paymentIntentSecret =
      monetarySettings.fee && settings.stripeConfig ?
        await Payments.createPaymentIntent({
          storefrontId: settings.storefrontId,
          amount: monetarySettings.fee.amount,
          currencyCode: order.currencyCode,
          stripeConfig: settings.stripeConfig,
          customerEmail: order.email,
        })
      : undefined;

    return {
      claims: lineItemClaims,
      paymentIntentSecret,
      ...(monetarySettings.fee && {
        fee: {
          amount: formatDisplayValue(toCurrency(order.currencyCode))(
            monetarySettings.fee.amount,
          ),
          displayName: monetarySettings.fee.displayName,
        },
      }),
    };
  });
